import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";
import { PropertyThumbnail } from "./";
import { toast } from "react-hot-toast";

import axios from "../api/axios";
import { useSelector } from "react-redux";

export default function ChangeAssigneeOverlay({
  item,
  closeConfirmation,
  updatedAssignee,
  setUpdatedAssignee,
}) {
  const [open, setOpen] = useState(true);
  const state = useSelector((state) => state.UserReducer);
  const teamsListUrl = "/team";
  const usersByTeamUrl = "/user/team";
  const serviceTicketUrl = "/serviceticket";

  const [targetAssigneeId, setTargetAssigneeId] = useState(null);
  const [teamsServerData, setTeamsServerData] = useState([]);
  const getTeamsList = (serviceTypeId) => {
    try {
      axios
        .get(teamsListUrl + "/" + serviceTypeId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.teams?.length > 0) {
            setTeamsServerData(response.data.teams);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [teamUsersServerData, setTeamUsersServerData] = useState([]);
  const getTeamUsers = (teamId) => {
    try {
      axios
        .get(usersByTeamUrl + "/" + teamId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.users?.length > 0) {
            setTeamUsersServerData(response.data.users);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const setAssignee = () => {
    try {
      axios
        .put(
          serviceTicketUrl + "/assignee/" + item._id,
          JSON.stringify({
            assigneeId: targetAssigneeId,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setUpdatedAssignee(updatedAssignee + 1);
          } else {
            toast.error(response?.data?.message);
          }
          setOpen(false);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  useEffect(() => {
    getTeamsList(item?.serviceTypeId?._id);
  }, [item._id]);

  const cancelButtonRef = useRef(null);
  return (
    <Transition.Root
      show={open}
      as={Fragment}
      afterLeave={() => {
        closeConfirmation();
      }}>
      <Dialog
        as='div'
        className='relative z-[60]'
        initialFocus={cancelButtonRef}
        onClose={() => {
          setOpen(false);
        }}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'>
          <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
        </Transition.Child>

        <div className='fixed z-50 inset-0 overflow-y-auto bg-gray-200 bg-opacity-60'>
          <div className='flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'>
              <Dialog.Panel className='relative bg-white rounded-sm text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full'>
                <div className='w-full h-full bg-white p-4'>
                  <div className='flex flex-col gap-2'>
                    <div className='flex justify-between'>
                      <span className='font-semibold text-yellow-dark'>
                        #{item.serviceTicketID}
                      </span>
                      <div className='font-semibold text-sm mt-0.5 text-gray-700'>
                        {item?.serviceTypeId ? item?.serviceTypeId?.name : "--"}{" "}
                        &gt;{" "}
                        {item?.subServiceTypeId
                          ? item?.subServiceTypeId?.name
                          : "--"}
                      </div>
                    </div>
                    <div className='flex justify-between'>
                      <div className='flex flex-col gap-0'>
                        <span className='font-semibold text-sm text-gray-700'>
                          Existing Assignee
                        </span>
                        {item.assignee?._id ? (
                          <div className='bg-yellow-50  py-1.5 px-2 rounded-sm flex flex-nowrap justify-center gap-2 hover:bg-yellow-2 duration-300'>
                            <img
                              src={
                                item.assignee?.avatar
                                  ? item.assignee?.avatar
                                  : "/assets/images/user.png"
                              }
                              alt='avatar'
                              referrerPolicy='no-referrer'
                              className='mt-0.5h-4 w-4 rounded-full ring-1 ring-yellow-2'
                            />
                            <span className='font-semibold text-sm text-yellow-dark'>
                              {item.assignee?.fullname
                                ? item.assignee.fullname
                                : item.assignee.firstname}
                            </span>
                          </div>
                        ) : (
                          <div className='bg-gray-200 py-1.5 px-2 rounded-sm flex flex-nowrap justify-center gap-2'>
                            <img
                              src={"/assets/images/user.png"}
                              alt='avatar'
                              referrerPolicy='no-referrer'
                              className='mt-0.5 h-4 w-4 rounded-full ring-1 ring-yellow-2'
                            />
                            <span className='font-semibold text-sm text-gray-100'>
                              UnAssigned
                            </span>
                          </div>
                        )}
                      </div>

                      <div className='font-semibold text-md mt-0.5'>&gt;</div>
                      <div className='flex flex-col gap-1 w-7/12'>
                        <span className='font-semibold text-sm text-gray-700'>
                          Target Assignee
                        </span>
                        <div className='mt-1'>
                          <select
                            className={`block w-8/12 py-1 px-2 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                            onChange={(e) => {
                              e.preventDefault();
                              if (e.target.value !== "")
                                getTeamUsers(e.target.value);
                            }}>
                            <option value=''>Select Team</option>
                            {teamsServerData.length > 0 ? (
                              teamsServerData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                        </div>
                        <div className='mt-1 w-full'>
                          <select
                            className={`block w-8/12 py-1 px-2 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                            onChange={(e) => {
                              e.preventDefault();
                              if (e.target.value !== "")
                                setTargetAssigneeId(e.target.value);
                            }}>
                            <option value=''>Select Assignee</option>
                            {teamUsersServerData.length > 0 ? (
                              teamUsersServerData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.fullname
                                    ? item.fullname
                                    : item.firstname}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse'>
                      <button
                        type='button'
                        className='w-full inline-flex justify-center rounded-sm shadow-sm px-3 py-1 bg-yellow-3 text-base font-medium text-white hover:bg-yellow-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm'
                        onClick={() => {
                          setAssignee();
                        }}>
                        Update
                      </button>
                      <button
                        type='button'
                        className='mt-3 w-full inline-flex justify-center rounded-sm border border-gray-300 shadow-sm px-2 py-1 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'
                        onClick={() => {
                          setOpen(false);
                        }}
                        ref={cancelButtonRef}>
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
